import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveConstraint } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ConstraintRemoval(props: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeConstraint } = useRemoveConstraint(
    props.constraint,
  );

  return (
    <Modal
      header={t("constraintRemoval.title")}
      headerClassName={styles.header}
      close={props.cancel}
    >
      <div className={styles.main}>
        <p className={styles.message}>{t("constraintRemoval.message")}</p>
        <div className={styles.buttons}>
          <Button type="cancel" press={props.cancel}>
            {t("constraintRemoval.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() => removeConstraint(props.constraint)}
          >
            {t("constraintRemoval.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ConstraintRemoval };
